"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DownloadSortButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const React = require("react");
const Pages_1 = require("Views/Partials/Pages");
const SortButton_1 = require("../SortButton");
const search_1 = require("src/search");
const app_1 = require("app");
const DownloadSortButton = ({ sortBy, onChange, setIsContentLoading, selectedFilters, className, }) => {
    const onChangeSort = (sortBy) => {
        setIsContentLoading(true);
        onChange(sortBy);
    };
    const isVisible = React.useMemo(() => {
        const { type, downloadSoftwareType } = selectedFilters;
        if (!type && !downloadSoftwareType) {
            return false;
        }
        const isDownloadTabSelected = (type === null || type === void 0 ? void 0 : type[0]) === search_1.FullTextSearchFilterTypeKeys.DOWNLOAD;
        const isDownloadSoftwareTypesOptionSelected = (downloadSoftwareType === null || downloadSoftwareType === void 0 ? void 0 : downloadSoftwareType.length) > 0;
        return isDownloadTabSelected && isDownloadSoftwareTypesOptionSelected;
    }, [selectedFilters]);
    return (isVisible && ((0, jsx_runtime_1.jsx)("div", { className: (0, app_1.cn)('search-download-sort md:flex md:justify-end', className), children: (0, jsx_runtime_1.jsx)(SortButton_1.SortButton, { label: Pages_1.PageContext.dictionary.sortBtnLabel, onChange: onChangeSort, options: Pages_1.PageContext.sortOptions, selected: sortBy }) })));
};
exports.DownloadSortButton = DownloadSortButton;
exports.default = exports.DownloadSortButton;
